export const MEASUREMENT_TYPE_GROUPS = {
  BODY_MASS_INDEX: 'body_mass_index',
  BODY_COMPOSITION: 'body_composition',
  MORPHOMETRICS: 'morphometrics',
  METABOLIC_RATES: 'metabolic_rates',
  BODY_VITALS: 'body_vitals',
};

export const MEASUREMENT_SETTING_TYPE_OPTIONS = {
  CUSTOM: 'custom',
};



// WEBPACK FOOTER //
// ./src/constants/measurement-types.js